import type { AxiosInstance, AxiosRequestConfig } from "axios";
import { getToken, logoutUser } from "~/routes/login/frappeAuth";
import { ewayBillApi, helper, helperV2, remixApi, serviceApi, validatorApi } from "~/utils/config/api";
import { util } from "~/utils/util";
import * as Sentry from '@sentry/react';


export interface ExtendedAxiosRequestConfig extends AxiosRequestConfig {
  apiClientKey: string;
}
// Centralized Axios instances
const apiClients: Record<string, AxiosInstance> = {
  help: helper,
  helpV2: helperV2,
  validator: validatorApi,
  service: serviceApi,
  remixApi:remixApi,
  ewayBillApi:ewayBillApi
};

export const callApi = async (config: ExtendedAxiosRequestConfig, retried = false): Promise<any> => {
  const { apiClientKey, ...axiosConfig } = config;
  let token: string | null | undefined;  
  try {
    token = await getToken(axiosConfig?.url);
    const client = apiClients[apiClientKey];

    if (!client) {
      throw new Error(`API client with key "${apiClientKey}" not found`);
    }

    const response = await client({
      ...axiosConfig,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error: any) {
    const messageObj = error?.response?.data?.message;
    const nestedMessage =
      typeof messageObj === "string"
        ? messageObj
        : messageObj?.cause?.failure?.message;

    const message =
      nestedMessage ||
      error?.response?.data?.error ||
      error?.message ||
      "An unknown error occurred";

    const failureTag = messageObj?.cause?.failure?._tag;
    const isExpired = /expired/i.test(message) || failureTag === "VALIDATION_ERROR_SERVER";

    if (isExpired && !retried) {
      console.log('Frappe token expired, retrying...')
      Sentry.captureException(error);
      const newToken = await getToken(axiosConfig?.url);
      if (newToken && newToken !== token) {
        return callApi(config, true);
      }
    }

    if (isExpired) {
      console.log('Frappe token expired')
      Sentry.captureException(error);
      logoutUser()
    }
    throw new Error(util.handleApiError(error).message);
  }
};
